import { HomeLayoutProps } from "@app/layouts/Home/Elements/utils";
import AppNewsletter from "@components/Modules/Newsletter/AppNewsletter";
import { configHome, configNewsletter } from "@pub/config";
import { Button, ResponsiveImage } from "@sphtech/dmg-design-system";
import cx from "classnames";

import {
  facebookIcon,
  instagramIcon,
  tiktokIcon,
  youtubeIcon,
} from "../icons/socialIcons";
import styles from "./magnewsletter.module.css";

const MagNewsletter = ({
  data,
}: {
  data: Pick<HomeLayoutProps["data"], "magazineIssues">;
}) => {
  const magImage = data.magazineIssues.items[0];
  const magInfo = data.magazineIssues.subscriptionInfo;

  const newsLetterProps = {
    backgroundImage: configHome.newsletter?.containerImageBg || "",
    newsletterCtaText: configHome.newsletter?.newsletterCtaText || "SIGN UP",
    emailPlaceHolder: {
      placeholder: configNewsletter.emailPlaceHolderText || "Email Address",
    },
    newsletterTitle: configHome.newsletter?.newsletterTitle || "",
    newsletterBody: configHome.newsletter?.newsletterBody || "",
    newsletterLang: configHome.newsletter?.newsletterLang || "",
    subscriptionMessage: configNewsletter.subscriptionMessage,
  };

  return (
    <div className={styles.magNewsContainer}>
      <div className={styles.gridTemplate}>
        <div className={cx(styles.areaMagazine, styles.magazineContainer)}>
          <div className={styles.imageContainer}>
            {magImage && (
              <ResponsiveImage
                src={magImage.image}
                {...magImage}
                loading="lazy"
              />
            )}
          </div>

          <h2 className={styles.heading}>{magInfo?.heading}</h2>
          <p className={styles.description}>{magInfo?.description}</p>
          {magInfo && (
            <Button
              href={magInfo.buttonUrl}
              target="_blank"
              variant="primary"
              data-layout-position="magazinesubbutton"
            >
              {magInfo.buttonText}
            </Button>
          )}
        </div>

        <div className={cx(styles.areaNewsletter, styles.newsletterContainer)}>
          <AppNewsletter {...newsLetterProps} />
        </div>

        <div className={cx(styles.areaIcons, styles.contactUsContainer)}>
          <p className={styles.contactUsText}>关注我们</p>

          <div className={styles.iconsContainer}>
            <a
              href="https://www.instagram.com/nuyousingapore"
              className={styles.icon}
              target="_blank"
              rel="noopener noreferrer"
            >
              {instagramIcon}
            </a>
            <a
              href="https://www.facebook.com/nuyousingapore"
              className={styles.icon}
              target="_blank"
              rel="noopener noreferrer"
            >
              {facebookIcon}
            </a>
            <a
              href="https://www.youtube.com/channel/UC2XRtoiJRP7N_027OUUbL-w"
              className={styles.icon}
              target="_blank"
              rel="noopener noreferrer"
            >
              {youtubeIcon}
            </a>
            <a
              href="https://www.tiktok.com/@nuyousingapore"
              className={styles.icon}
              target="_blank"
              rel="noopener noreferrer"
            >
              {tiktokIcon}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MagNewsletter;
